import DrawerMenu from 'app/components/common/DrawerMenu';
import { P } from 'app/components/common/Typography';
import React, { useState } from 'react';
import { Drawer, NavBar, Button } from 'mui';
import TylerImage from 'images/doctors/tyler.png';
import SetProductDialog from '@setproduct-ui/core/Dialog/Dialog';
import { useAppDispatch, useAppSelector } from 'app/helpers/hooks';
import * as selectors from 'app/selectors/customer';
import { apiRequestUserCommand } from 'app/actions/customer';
import { push } from 'connected-react-router/immutable';
import { selectFurthestProductStepPath } from 'app/selectors/customer';
import { AvailableProducts } from 'app/constants/Products';

const TestosteroneTestimonials = ({ setDialogOpen }) => {
  const dispatch = useAppDispatch();
  const intake = useAppSelector(selectors.selectCurrentIntake);
  const onSuccessActionCreator = (_, stateAfterSuccess) =>
    push(selectFurthestProductStepPath({ customer: stateAfterSuccess }, AvailableProducts.King));
  const action = apiRequestUserCommand({
    cmdType: 'answer_questions',
    params: { testosterone_testimonials: true, intake: intake.get('name') },
    context: {
      onSuccessActionCreator,
    },
  });
  const handleClose = () => {
    setDialogOpen(false);
    dispatch(action);
  };
  return (
    <div>
      <Drawer sideContent={<DrawerMenu loggedIn={false} />}>
        <NavBar />
        <div className="centered-content tyler">
          <img className="tyler-image" src={TylerImage} alt="Tyler, Personal Trainer" />
          <P className="interstitial_content">
            “I feel significant changes to my mental and physical state. I am able to workout longer and recover
            faster.”
          </P>
          <div className="interstitial_content tyler-copy">
            – Tyler, Personal Trainer <br />
            Maximus client since 2022
          </div>
          <Button className="close" onClick={handleClose}>
            Next
          </Button>
        </div>
      </Drawer>
    </div>
  );
};

const TestosteroneTestimonialsPage = () => {
  const [dialogOpen, setDialogOpen] = useState(true);
  return (
    <SetProductDialog
      isOpen={dialogOpen}
      text={<TestosteroneTestimonials setDialogOpen={setDialogOpen} />}
      showCloseModalIcon={false}
      dialogClassName="interstitial_container"
    />
  );
};
export default TestosteroneTestimonialsPage;
